import { addScript } from "../../bundles/helpers/add-script";

/** *
 * Класс датапикера
 * @example
 * Аттрибуты:
 * data-container (string, default = '') - контейнер, куда будет помещён датапикер
 * data-position (string, default = 'bottom left') - позиция датапикера
 * data-view (string, default = 'days') - начальное отображение даты (days, months, years)
 * data-min-date (Date | string | number, default = '') - минимальная дата для выбора
 * data-max-date (Date | string | number, default = '') - максимальная дата для выбора
 */
class Datepicker {
  /** *
   * Конструктор
   * @param elem{HTMLElement} - элемент с классом datepicker
   */
  constructor(elem) {
    this.block = elem;
    this.input = this.block.querySelector('input');

    this.options = {
      autoClose: true,
      classes: 'datepicker__picker',
      navTitles: {
        days: 'MMMM yyyy',
        months: 'yyyy',
        years: 'yyyy1 - yyyy2',
      },
      prevHtml: '<i class="fi fi_icon_chevron-left"></i>',
      nextHtml: '<i class="fi fi_icon_chevron-right"></i>',
      container: this.block.dataset['container'] || '',
      position: this.block.dataset['position'] || 'bottom left',
      view: this.block.dataset['view'] || 'days',
      minDate: this.block.dataset['minDate'] || '',
      maxDate: this.block.dataset['maxDate'] || '',
      onSelect: ({formattedDate}) => {
        this.block.dispatchEvent(new CustomEvent('ivDatepickerSelect', {bubbles: true, detail: formattedDate})); // Событие для vue компонента
      },
    };

    this.change = this.change.bind(this);
    this.keydown = this.keydown.bind(this);

    if (this.input) this.init();
  }

  async init() {
    if (!window.AirDatepicker) await addScript(PUBLIC_PATH + 'vendor/airdatepicker.vendor.js');
    this.datepicker = new AirDatepicker(this.input, this.options);

    this.change();

    this.input.addEventListener('change', this.change);
    this.input.addEventListener('keydown', this.keydown);

    this.block.classList.add('datepicker_init');
  }

  change() {
    const value = this.input.value;
    const pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
    const date = new Date(value.replace(pattern, '$3-$2-$1'));

    if (!isNaN(date)) {
      if (this.datepicker.minDate && date < this.datepicker.minDate || this.datepicker.maxDate && date > this.datepicker.maxDate) return;

      this.datepicker.selectDate(date);
      this.datepicker.setFocusDate(date, {viewDateTransition: true});
    } else {
      this.datepicker.clear();
    }
  }

  keydown(event) {
    if (event.code === 'Enter') {
      event.preventDefault(); // Если не отменить датапикер стирает значение при повторном вводе
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
    }
  }

  static init() {
    Array.from(document.querySelectorAll('.datepicker:not(.datepicker_init)')).forEach((elem) => new Datepicker(elem));
  }
}

document.addEventListener('DOMContentLoaded', Datepicker.init);

// Экспорт;
window.Block = window.Block ? window.Block : {};
window.Block.Datepicker = Datepicker;
